import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-lesson-plan-warning-dialog',
  templateUrl: './lesson-plan-warning-dialog.component.html',
  styleUrls: ['./lesson-plan-warning-dialog.component.scss']
})
export class LessonPlanWarningDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<LessonPlanWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  addContent(): void {
    this.dialogRef.close(true);
  }

}
